const openModal = () => {
  $('#pick_submit').modal();
};

export default openModal;
